<template>
<transition
    enter-active-class="animated slideInUp"
    leave-active-class="animated slideOutDown"
    appear
    v-if="showWalletOpenerBanner"
>
    <div class="inset-x-0 bottom-0 fixed bg-white z-50" v-cloak>
        <div class="max-w-4xl mx-auto w-full h-48 sm:h-32 flex items-start justify-center ">

            <div class="w-1/4 sm:w-1/5 md:w-1/4 lg:w-auto h-full flex items-start pr-4">
                <div class="relative w-full h-48 sm:h-32">
                    <small-image
                        :url="'wallet_openers/' + template.image"
                        sizes="208px"
                        class="absolute lg:relative top-0 right-0 mt-4 max-w-double w-double md:w-48"
                    />
                </div>
            </div>

            <div class="w-1/2 md:w-2/5 sm:flex-grow h-full py-4 box">
                <div class="border-r border-dotted border-gray">

                    <b class="block text-base leading-normal sm:mb-3">
                        {{ template.banner_heading  }}:
                    </b>

                    <div class="flex justify-left items-end">
                        <div>
                            <div
                                class="countdown leading-none flex leading-normal items-end text-base text-accent-600 font-bold text-xl">
                                {{ timeLeft }}
                            </div>

                            <div class="text-gray-800 text-sm leading-normal font-thin mr-4">
                                {{ template.banner_countdown_label }}
                            </div>
                        </div>

                        <div class="absolute sm:relative w-full sm:w-auto bottom-0 inset-x-0">
                            <div class="px-6 pb-2 sm:p-0 sm:pl-6">
                                <a href="/wallet_opener" class="btn btn-primary border-0 w-full text-center">
                                    {{ template.banner_button }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-1/4 sm:w-24 md:w-1/5 max-w-48 h-24 sm:h-full">
                <div class="flex h-full items-center justify-center md:justify-left">
                    <div class="inline-block text-center">
                        <a
                            @click.prevent="hide"
                            href="#"
                            class="flex items-center text-xl text-accent-600"
                        >
                            <span class="hidden md:block">
                                {{ template.banner_decline_text }}
                            </span>
                            <svg-icon url="fas/xmark" class="ml-2 h-6 w-6 cursor-pointer text-accent-600" />
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</transition>
</template>

<script>
    import { mapGetters, mapActions, mapState } from 'vuex'

    export default {

        data() {
            return {
                interval: null,
                timeLeft: null,
            }
        },

        mounted() {
            if (this.showWalletOpenerBanner) {
                this.interval = setInterval(() => this.countDown(), 1000);
            }
        },

        computed: {
            ...mapState('general', {
                'template': 'walletOpenerTemplate',
            }),
            ...mapGetters('general', ['_', 'hasWalletOpener', 'walletOpener', "showWalletOpenerBanner"]),
        },

        methods: {
            ...mapActions('general', ['hideWalletOpener']),

            countDown() {
                let countDownDate = new Date(this.walletOpener.reserved_to);
                let distance = countDownDate - new Date();
                distance = distance < 0 ? 0 : distance;

                let days = Math.floor(distance / (1000 * 60 * 60 * 24));
                let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((distance % (1000 * 60)) / 1000);

                this.timeLeft = this.pad((days * 24) + hours,2) + "  :  " + this.pad(minutes,2) + "  :  " + this.pad(seconds,2);

                if (distance == 0) {
                    clearInterval(this.interval);
                }
            },

            pad(num, size) {
                var s = num+"";
                while (s.length < size) s = "0" + s;
                return s;
            },

            hide() {
                this.show = false;
                this.hideWalletOpener();
            },
        }

    }
</script>
